// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddCourseData, AddCourseErrors, AddCourseResponses, AssignUsersData, AssignUsersErrors, AssignUsersResponses, AssignUsersToChecklistData, AssignUsersToChecklistErrors, AssignUsersToChecklistResponses, BrowseStructureData, BrowseStructureErrors, BrowseStructureResponses, CloneAsSystemPlanData, CloneAsSystemPlanErrors, CloneAsSystemPlanResponses, ClonePlanData, ClonePlanErrors, ClonePlanResponses, CreateAnswerData, CreateAnswerErrors, CreateAnswerResponses, CreatePlanData, CreatePlanErrors, CreatePlanResponses, CreateQuizData, CreateQuizErrors, CreateQuizResponses, DeleteCategoryByCountryCodeAndIdData, DeleteCategoryByCountryCodeAndIdErrors, DeleteCategoryByCountryCodeAndIdResponses, DeleteCourseData, DeleteCourseErrors, DeleteCourseResponses, DeleteDocumentData, DeleteDocumentErrors, DeleteDocumentResponses, DeleteQuizData, DeleteQuizErrors, DeleteQuizResponses, DiffData, DiffErrors, DiffResponses, GenerateCourseReportData, GenerateCourseReportErrors, GenerateCourseReportResponses, GetActivePlanAssignmentsData, GetActivePlanAssignmentsErrors, GetActivePlanAssignmentsResponses, GetAllCoursesData, GetAllCoursesErrors, GetAllCoursesResponses, GetAuthData, GetAuthErrors, GetAuthResponses, GetCategoriesByCountryCodeData, GetCategoriesByCountryCodeErrors, GetCategoriesByCountryCodeResponses, GetCategoryData, GetCategoryErrors, GetCategoryIconsData, GetCategoryIconsErrors, GetCategoryIconsResponses, GetCategoryV2Data, GetCategoryV2Errors, GetCategoryV2Responses, GetComplianceCoursesData, GetComplianceCoursesErrors, GetComplianceCoursesResponses, GetConfigurationData, GetConfigurationErrors, GetConfigurationResponses, GetCourseByIdData, GetCourseByIdErrors, GetCourseByIdResponses, GetDocumentData, GetDocumentErrors, GetDocumentResponses, GetExperimentsConfigData, GetExperimentsConfigErrors, GetExperimentsConfigResponses, GetManagedPlansData, GetManagedPlansErrors, GetManagedPlansResponses, GetOperatorCourseSettingsData, GetOperatorCourseSettingsErrors, GetOperatorCourseSettingsResponses, GetOperatorsData, GetOperatorsErrors, GetOperatorsResponses, GetPlanAndAssignmentsData, GetPlanAndAssignmentsErrors, GetPlanAndAssignmentsResponses, GetPlanReportData, GetPlanReportErrors, GetPlanReportResponses, GetPlansSummaryData, GetPlansSummaryErrors, GetPlansSummaryResponses, GetProcedureIconsData, GetProcedureIconsErrors, GetProcedureIconsResponses, GetQuizDetailsData, GetQuizDetailsErrors, GetQuizDetailsResponses, GetQuizzesData, GetQuizzesErrors, GetQuizzesResponses, GetResourceData, GetResourceErrors, GetResourceResponses, GetSmartSearchLocationsData, GetSmartSearchLocationsErrors, GetSmartSearchLocationsResponses, GetSqsslData, GetSqsslErrors, GetSqsslResponses, GetSystemPlansData, GetSystemPlansErrors, GetSystemPlansResponses, GetTranslationsData, GetTranslationsErrors, GetTranslationsResponses, GetUserPlanAssignmentSummariesData, GetUserPlanAssignmentSummariesErrors, GetUserPlanAssignmentSummariesResponses, GetUserPreferencesData, GetUserPreferencesErrors, GetUserPreferencesResponses, GetUsersData, GetUsersErrors, GetUsersForLocationsData, GetUsersForLocationsErrors, GetUsersForLocationsResponses, GetUsersResponses, GetUsersSummaryReportData, GetUsersSummaryReportErrors, GetUsersSummaryReportResponses, GetUserSummaryReportData, GetUserSummaryReportErrors, GetUserSummaryReportResponses, HardDeleteQuizData, HardDeleteQuizErrors, HardDeleteQuizResponses, HeartbeatData, HeartbeatErrors, HeartbeatResponses, HeartbeatTrainTogetherData, HeartbeatTrainTogetherErrors, HeartbeatTrainTogetherResponses, LearnUponWebhookData, LearnUponWebhookErrors, LearnUponWebhookResponses, ListEnrollmentsByCourseData, ListEnrollmentsByCourseErrors, ListEnrollmentsByCourseResponses, MarkPlanAsCompleteData, MarkPlanAsCompleteErrors, MarkPlanAsCompleteResponses, PatchAutoAssignData, PatchAutoAssignErrors, PatchAutoAssignResponses, PatchPlanNameData, PatchPlanNameErrors, PatchPlanNameResponses, PatchPlanStatusData, PatchPlanStatusErrors, PatchPlanStatusResponses, PatchQuizNameData, PatchQuizNameErrors, PatchQuizNameResponses, ResetPlanStepsData, ResetPlanStepsErrors, ResetPlanStepsResponses, RewritePlanReferencesData, RewritePlanReferencesErrors, RewritePlanReferencesResponses, RunDatasetExperimentData, RunDatasetExperimentErrors, RunDatasetExperimentResponses, SaveCategoriesData, SaveCategoriesErrors, SaveCategoriesResponses, SaveCategoryData, SaveCategoryErrors, SaveCategoryResponses, SaveDocumentsData, SaveDocumentsErrors, SaveDocumentsResponses, SaveUserPreferencesData, SaveUserPreferencesErrors, SaveUserPreferencesResponses, SearchClickFeedbackData, SearchClickFeedbackErrors, SearchClickFeedbackResponses, SearchData, SearchErrors, SearchResponses, SetAuthCookieData, SetAuthCookieErrors, SetAuthCookieResponses, SetOperatorCourseSettingData, SetOperatorCourseSettingErrors, SetOperatorCourseSettingResponses, SwapData, SwapErrors, SwapResponses, SynchronizeUserData, SynchronizeUserErrors, SynchronizeUserResponses, TrainTogetherMarkPlanAsCompleteData, TrainTogetherMarkPlanAsCompleteErrors, TrainTogetherMarkPlanAsCompleteResponses, TrainTogetherUpdateStepStatusData, TrainTogetherUpdateStepStatusErrors, TrainTogetherUpdateStepStatusResponses, UnassignUsersData, UnassignUsersErrors, UnassignUsersResponses, UpdateCourseData, UpdateCourseErrors, UpdateCourseResponses, UpdateDueDateData, UpdateDueDateErrors, UpdateDueDateResponses, UpdatePlanData, UpdatePlanErrors, UpdatePlanResponses, UpdateQuizData, UpdateQuizErrors, UpdateQuizResponses, UpdateSmartSearchOptInData, UpdateSmartSearchOptInErrors, UpdateSmartSearchOptInResponses, UpdateStepStatusData, UpdateStepStatusErrors, UpdateStepStatusResponses, UpdateUserComplianceCourseDurationData, UpdateUserComplianceCourseDurationErrors, UpdateUserComplianceCourseDurationResponses, UpsertReadonlySubscriptionData, UpsertReadonlySubscriptionErrors, UpsertReadonlySubscriptionResponses, UpsertSmartSearchFeedbackData, UpsertSmartSearchFeedbackErrors, UpsertSmartSearchFeedbackResponses, WebhookQuizData, WebhookQuizErrors, WebhookQuizResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Generate a grounded AI answer for a natural-language query
 *
 * Server-to-server endpoint for answering questions based on CFA procedures
 */
export const createAnswer = <ThrowOnError extends boolean = false>(options: Options<CreateAnswerData, ThrowOnError>): RequestResult<CreateAnswerResponses, CreateAnswerErrors, ThrowOnError> => (options.client ?? client).post<CreateAnswerResponses, CreateAnswerErrors, ThrowOnError>({
    url: '/answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run a dataset experiment
 *
 * Triggers an asynchronous experiment that runs each dataset item through the answers pipeline and reports results back to Langfuse as dataset run items.
 */
export const runDatasetExperiment = <ThrowOnError extends boolean = false>(options: Options<RunDatasetExperimentData, ThrowOnError>): RequestResult<RunDatasetExperimentResponses, RunDatasetExperimentErrors, ThrowOnError> => (options.client ?? client).post<RunDatasetExperimentResponses, RunDatasetExperimentErrors, ThrowOnError>({
    url: '/answers/experiments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve Langfuse configuration for dataset experiments
 *
 * Returns Langfuse configuration from the Pathway project needed to set up dataset experiments.
 */
export const getExperimentsConfig = <ThrowOnError extends boolean = false>(options?: Options<GetExperimentsConfigData, ThrowOnError>): RequestResult<GetExperimentsConfigResponses, GetExperimentsConfigErrors, ThrowOnError> => (options?.client ?? client).get<GetExperimentsConfigResponses, GetExperimentsConfigErrors, ThrowOnError>({ url: '/answers/experiments/config', ...options });

/**
 * Sets the authorization cookies and returns the users profile / feature set
 */
export const getAuth = <ThrowOnError extends boolean = false>(options?: Options<GetAuthData, ThrowOnError>): RequestResult<GetAuthResponses, GetAuthErrors, ThrowOnError> => (options?.client ?? client).get<GetAuthResponses, GetAuthErrors, ThrowOnError>({ url: '/auth', ...options });

/**
 * Get Browse structure
 *
 * Returns complete browse structure by Country and Language
 */
export const browseStructure = <ThrowOnError extends boolean = false>(options?: Options<BrowseStructureData, ThrowOnError>): RequestResult<BrowseStructureResponses, BrowseStructureErrors, ThrowOnError> => (options?.client ?? client).get<BrowseStructureResponses, BrowseStructureErrors, ThrowOnError>({ url: '/browse', ...options });

/**
 * Get Categories by Country Code
 */
export const getCategoriesByCountryCode = <ThrowOnError extends boolean = false>(options?: Options<GetCategoriesByCountryCodeData, ThrowOnError>): RequestResult<GetCategoriesByCountryCodeResponses, GetCategoriesByCountryCodeErrors, ThrowOnError> => (options?.client ?? client).get<GetCategoriesByCountryCodeResponses, GetCategoriesByCountryCodeErrors, ThrowOnError>({ url: '/categories', ...options });

/**
 * Add or update Categories List
 */
export const saveCategories = <ThrowOnError extends boolean = false>(options: Options<SaveCategoriesData, ThrowOnError>): RequestResult<SaveCategoriesResponses, SaveCategoriesErrors, ThrowOnError> => (options.client ?? client).post<SaveCategoriesResponses, SaveCategoriesErrors, ThrowOnError>({
    url: '/categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add or update single category
 */
export const saveCategory = <ThrowOnError extends boolean = false>(options: Options<SaveCategoryData, ThrowOnError>): RequestResult<SaveCategoryResponses, SaveCategoryErrors, ThrowOnError> => (options.client ?? client).put<SaveCategoryResponses, SaveCategoryErrors, ThrowOnError>({
    url: '/categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Category (v2)
 */
export const getCategoryV2 = <ThrowOnError extends boolean = false>(options: Options<GetCategoryV2Data, ThrowOnError>): RequestResult<GetCategoryV2Responses, GetCategoryV2Errors, ThrowOnError> => (options.client ?? client).get<GetCategoryV2Responses, GetCategoryV2Errors, ThrowOnError>({ url: '/categories/v2/{id}', ...options });

/**
 * Delete category by Country and ID
 */
export const deleteCategoryByCountryCodeAndId = <ThrowOnError extends boolean = false>(options: Options<DeleteCategoryByCountryCodeAndIdData, ThrowOnError>): RequestResult<DeleteCategoryByCountryCodeAndIdResponses, DeleteCategoryByCountryCodeAndIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCategoryByCountryCodeAndIdResponses, DeleteCategoryByCountryCodeAndIdErrors, ThrowOnError>({ url: '/categories/{country}/{id}', ...options });

/**
 * Get Category
 */
export const getCategory = <ThrowOnError extends boolean = false>(options: Options<GetCategoryData, ThrowOnError>): RequestResult<unknown, GetCategoryErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetCategoryErrors, ThrowOnError>({ url: '/categories/{id}', ...options });

/**
 * Returns the list of configured versions.
 *
 * Returns the list of configured versions.
 */
export const getConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetConfigurationData, ThrowOnError>): RequestResult<GetConfigurationResponses, GetConfigurationErrors, ThrowOnError> => (options?.client ?? client).get<GetConfigurationResponses, GetConfigurationErrors, ThrowOnError>({ url: '/configuration', ...options });

/**
 * List All Courses
 *
 * List All Courses
 *
 * @deprecated
 */
export const getAllCourses = <ThrowOnError extends boolean = false>(options?: Options<GetAllCoursesData, ThrowOnError>): RequestResult<GetAllCoursesResponses, GetAllCoursesErrors, ThrowOnError> => (options?.client ?? client).get<GetAllCoursesResponses, GetAllCoursesErrors, ThrowOnError>({ url: '/courses', ...options });

/**
 * Add a Course
 *
 * @deprecated
 */
export const addCourse = <ThrowOnError extends boolean = false>(options: Options<AddCourseData, ThrowOnError>): RequestResult<AddCourseResponses, AddCourseErrors, ThrowOnError> => (options.client ?? client).post<AddCourseResponses, AddCourseErrors, ThrowOnError>({
    url: '/courses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign one or more Team members to a Checklist
 *
 * @deprecated
 */
export const assignUsersToChecklist = <ThrowOnError extends boolean = false>(options: Options<AssignUsersToChecklistData, ThrowOnError>): RequestResult<AssignUsersToChecklistResponses, AssignUsersToChecklistErrors, ThrowOnError> => (options.client ?? client).post<AssignUsersToChecklistResponses, AssignUsersToChecklistErrors, ThrowOnError>({
    url: '/courses/assign/{courseId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Status of all current enrollments to this course by optional location
 *
 * @deprecated
 */
export const listEnrollmentsByCourse = <ThrowOnError extends boolean = false>(options: Options<ListEnrollmentsByCourseData, ThrowOnError>): RequestResult<ListEnrollmentsByCourseResponses, ListEnrollmentsByCourseErrors, ThrowOnError> => (options.client ?? client).get<ListEnrollmentsByCourseResponses, ListEnrollmentsByCourseErrors, ThrowOnError>({ url: '/courses/assigned/{courseId}', ...options });

/**
 * Gets compliance courses based on country selected in user's profile
 *
 * @deprecated
 */
export const getComplianceCourses = <ThrowOnError extends boolean = false>(options?: Options<GetComplianceCoursesData, ThrowOnError>): RequestResult<GetComplianceCoursesResponses, GetComplianceCoursesErrors, ThrowOnError> => (options?.client ?? client).get<GetComplianceCoursesResponses, GetComplianceCoursesErrors, ThrowOnError>({ url: '/courses/compliance', ...options });

/**
 * Sensitive data report on course by location
 *
 * @deprecated
 */
export const generateCourseReport = <ThrowOnError extends boolean = false>(options: Options<GenerateCourseReportData, ThrowOnError>): RequestResult<GenerateCourseReportResponses, GenerateCourseReportErrors, ThrowOnError> => (options.client ?? client).get<GenerateCourseReportResponses, GenerateCourseReportErrors, ThrowOnError>({ url: '/courses/report/{courseId}', ...options });

/**
 * Returns course settings for an operator
 *
 * @deprecated
 */
export const getOperatorCourseSettings = <ThrowOnError extends boolean = false>(options: Options<GetOperatorCourseSettingsData, ThrowOnError>): RequestResult<GetOperatorCourseSettingsResponses, GetOperatorCourseSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetOperatorCourseSettingsResponses, GetOperatorCourseSettingsErrors, ThrowOnError>({ url: '/courses/settings', ...options });

/**
 * Enables or Disables a course for an operator
 *
 * @deprecated
 */
export const setOperatorCourseSetting = <ThrowOnError extends boolean = false>(options: Options<SetOperatorCourseSettingData, ThrowOnError>): RequestResult<SetOperatorCourseSettingResponses, SetOperatorCourseSettingErrors, ThrowOnError> => (options.client ?? client).post<SetOperatorCourseSettingResponses, SetOperatorCourseSettingErrors, ThrowOnError>({ url: '/courses/settings/{courseId}/{enable}', ...options });

/**
 * Get SQSSO
 *
 * @deprecated
 */
export const getSqssl = <ThrowOnError extends boolean = false>(options: Options<GetSqsslData, ThrowOnError>): RequestResult<GetSqsslResponses, GetSqsslErrors, ThrowOnError> => (options.client ?? client).get<GetSqsslResponses, GetSqsslErrors, ThrowOnError>({ url: '/courses/sqsso/{courseId}', ...options });

/**
 * Synchronize User with LearnUpon
 *
 * @deprecated
 */
export const synchronizeUser = <ThrowOnError extends boolean = false>(options: Options<SynchronizeUserData, ThrowOnError>): RequestResult<SynchronizeUserResponses, SynchronizeUserErrors, ThrowOnError> => (options.client ?? client).post<SynchronizeUserResponses, SynchronizeUserErrors, ThrowOnError>({ url: '/courses/sync/{userId}', ...options });

/**
 * Handle LearnUpon webhook event
 *
 * @deprecated
 */
export const learnUponWebhook = <ThrowOnError extends boolean = false>(options: Options<LearnUponWebhookData, ThrowOnError>): RequestResult<LearnUponWebhookResponses, LearnUponWebhookErrors, ThrowOnError> => (options.client ?? client).post<LearnUponWebhookResponses, LearnUponWebhookErrors, ThrowOnError>({
    url: '/courses/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Course by ID
 *
 * @deprecated
 */
export const deleteCourse = <ThrowOnError extends boolean = false>(options: Options<DeleteCourseData, ThrowOnError>): RequestResult<DeleteCourseResponses, DeleteCourseErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCourseResponses, DeleteCourseErrors, ThrowOnError>({ url: '/courses/{id}', ...options });

/**
 * Update a course
 *
 * @deprecated
 */
export const updateCourse = <ThrowOnError extends boolean = false>(options: Options<UpdateCourseData, ThrowOnError>): RequestResult<UpdateCourseResponses, UpdateCourseErrors, ThrowOnError> => (options.client ?? client).put<UpdateCourseResponses, UpdateCourseErrors, ThrowOnError>({
    url: '/courses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Course by ID
 *
 * @deprecated
 */
export const getCourseById = <ThrowOnError extends boolean = false>(options: Options<GetCourseByIdData, ThrowOnError>): RequestResult<GetCourseByIdResponses, GetCourseByIdErrors, ThrowOnError> => (options.client ?? client).get<GetCourseByIdResponses, GetCourseByIdErrors, ThrowOnError>({ url: '/courses/{itemId}', ...options });

/**
 * Set course status by ID
 *
 * @deprecated
 */
export const updateUserComplianceCourseDuration = <ThrowOnError extends boolean = false>(options: Options<UpdateUserComplianceCourseDurationData, ThrowOnError>): RequestResult<UpdateUserComplianceCourseDurationResponses, UpdateUserComplianceCourseDurationErrors, ThrowOnError> => (options.client ?? client).post<UpdateUserComplianceCourseDurationResponses, UpdateUserComplianceCourseDurationErrors, ThrowOnError>({
    url: '/courses/{pathwayCourseId}/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add or update documents
 */
export const saveDocuments = <ThrowOnError extends boolean = false>(options: Options<SaveDocumentsData, ThrowOnError>): RequestResult<SaveDocumentsResponses, SaveDocumentsErrors, ThrowOnError> => (options.client ?? client).post<SaveDocumentsResponses, SaveDocumentsErrors, ThrowOnError>({
    url: '/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sets auth cookie in response header
 */
export const setAuthCookie = <ThrowOnError extends boolean = false>(options?: Options<SetAuthCookieData, ThrowOnError>): RequestResult<SetAuthCookieResponses, SetAuthCookieErrors, ThrowOnError> => (options?.client ?? client).get<SetAuthCookieResponses, SetAuthCookieErrors, ThrowOnError>({ url: '/documents/cookie', ...options });

/**
 * Delete document by ID
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(options?: Options<DeleteDocumentData, ThrowOnError>): RequestResult<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError>({ url: '/documents/{itemId}', ...options });

/**
 * Get document by ID
 */
export const getDocument = <ThrowOnError extends boolean = false>(options: Options<GetDocumentData, ThrowOnError>): RequestResult<GetDocumentResponses, GetDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentResponses, GetDocumentErrors, ThrowOnError>({ url: '/documents/{itemId}', ...options });

/**
 * Get a list of all category icons
 */
export const getCategoryIcons = <ThrowOnError extends boolean = false>(options?: Options<GetCategoryIconsData, ThrowOnError>): RequestResult<GetCategoryIconsResponses, GetCategoryIconsErrors, ThrowOnError> => (options?.client ?? client).get<GetCategoryIconsResponses, GetCategoryIconsErrors, ThrowOnError>({ url: '/icons/categories', ...options });

/**
 * Get a list of all procedure icons
 */
export const getProcedureIcons = <ThrowOnError extends boolean = false>(options?: Options<GetProcedureIconsData, ThrowOnError>): RequestResult<GetProcedureIconsResponses, GetProcedureIconsErrors, ThrowOnError> => (options?.client ?? client).get<GetProcedureIconsResponses, GetProcedureIconsErrors, ThrowOnError>({ url: '/icons/procedures', ...options });

/**
 * Get a report on all plans a user has build access to
 *
 * Get a report on all plans a user has build access to, status default is ACTIVE
 */
export const getPlansSummary = <ThrowOnError extends boolean = false>(options?: Options<GetPlansSummaryData, ThrowOnError>): RequestResult<GetPlansSummaryResponses, GetPlansSummaryErrors, ThrowOnError> => (options?.client ?? client).get<GetPlansSummaryResponses, GetPlansSummaryErrors, ThrowOnError>({ url: '/planReports/plans', ...options });

/**
 * Get a report for all users on a specific plan
 *
 * Get a report for all users on a specific plan
 */
export const getPlanReport = <ThrowOnError extends boolean = false>(options: Options<GetPlanReportData, ThrowOnError>): RequestResult<GetPlanReportResponses, GetPlanReportErrors, ThrowOnError> => (options.client ?? client).get<GetPlanReportResponses, GetPlanReportErrors, ThrowOnError>({ url: '/planReports/plans/{planId}', ...options });

/**
 * Get a report on all users plan progress for the passed in location numbers.
 *
 * Returns summary of user's overall plan progress on all active plans at the passed in location numbers.
 */
export const getUsersSummaryReport = <ThrowOnError extends boolean = false>(options: Options<GetUsersSummaryReportData, ThrowOnError>): RequestResult<GetUsersSummaryReportResponses, GetUsersSummaryReportErrors, ThrowOnError> => (options.client ?? client).get<GetUsersSummaryReportResponses, GetUsersSummaryReportErrors, ThrowOnError>({ url: '/planReports/users', ...options });

/**
 * Get a detailed plan summary report for a specific user
 *
 * Get a detailed plan summary report for a specific user
 */
export const getUserSummaryReport = <ThrowOnError extends boolean = false>(options: Options<GetUserSummaryReportData, ThrowOnError>): RequestResult<GetUserSummaryReportResponses, GetUserSummaryReportErrors, ThrowOnError> => (options.client ?? client).get<GetUserSummaryReportResponses, GetUserSummaryReportErrors, ThrowOnError>({ url: '/planReports/users/{userId}', ...options });

/**
 * Get manage plans for user's owner ids
 *
 * Get manage plans for logged in user's owner ids
 */
export const getManagedPlans = <ThrowOnError extends boolean = false>(options?: Options<GetManagedPlansData, ThrowOnError>): RequestResult<GetManagedPlansResponses, GetManagedPlansErrors, ThrowOnError> => (options?.client ?? client).get<GetManagedPlansResponses, GetManagedPlansErrors, ThrowOnError>({ url: '/plans', ...options });

/**
 * Create a new plan.
 */
export const createPlan = <ThrowOnError extends boolean = false>(options: Options<CreatePlanData, ThrowOnError>): RequestResult<CreatePlanResponses, CreatePlanErrors, ThrowOnError> => (options.client ?? client).post<CreatePlanResponses, CreatePlanErrors, ThrowOnError>({
    url: '/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get active assigned plans for user
 *
 * Get active assigned plans for logged in user
 */
export const getActivePlanAssignments = <ThrowOnError extends boolean = false>(options?: Options<GetActivePlanAssignmentsData, ThrowOnError>): RequestResult<GetActivePlanAssignmentsResponses, GetActivePlanAssignmentsErrors, ThrowOnError> => (options?.client ?? client).get<GetActivePlanAssignmentsResponses, GetActivePlanAssignmentsErrors, ThrowOnError>({ url: '/plans/assignments', ...options });

/**
 * Get all active system plans for user's business models
 *
 * Get active system plans for logged in user's business models
 */
export const getSystemPlans = <ThrowOnError extends boolean = false>(options?: Options<GetSystemPlansData, ThrowOnError>): RequestResult<GetSystemPlansResponses, GetSystemPlansErrors, ThrowOnError> => (options?.client ?? client).get<GetSystemPlansResponses, GetSystemPlansErrors, ThrowOnError>({ url: '/plans/system', ...options });

/**
 * Get plan by id along with all of its active assignments
 *
 * Get plan by id along with all of its active assignments
 */
export const getPlanAndAssignments = <ThrowOnError extends boolean = false>(options: Options<GetPlanAndAssignmentsData, ThrowOnError>): RequestResult<GetPlanAndAssignmentsResponses, GetPlanAndAssignmentsErrors, ThrowOnError> => (options.client ?? client).get<GetPlanAndAssignmentsResponses, GetPlanAndAssignmentsErrors, ThrowOnError>({ url: '/plans/{planId}', ...options });

/**
 * Update a plan.
 */
export const updatePlan = <ThrowOnError extends boolean = false>(options: Options<UpdatePlanData, ThrowOnError>): RequestResult<UpdatePlanResponses, UpdatePlanErrors, ThrowOnError> => (options.client ?? client).put<UpdatePlanResponses, UpdatePlanErrors, ThrowOnError>({
    url: '/plans/{planId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassign users from plan.
 */
export const unassignUsers = <ThrowOnError extends boolean = false>(options: Options<UnassignUsersData, ThrowOnError>): RequestResult<UnassignUsersResponses, UnassignUsersErrors, ThrowOnError> => (options.client ?? client).delete<UnassignUsersResponses, UnassignUsersErrors, ThrowOnError>({
    url: '/plans/{planId}/assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign plan to users.
 */
export const assignUsers = <ThrowOnError extends boolean = false>(options: Options<AssignUsersData, ThrowOnError>): RequestResult<AssignUsersResponses, AssignUsersErrors, ThrowOnError> => (options.client ?? client).post<AssignUsersResponses, AssignUsersErrors, ThrowOnError>({
    url: '/plans/{planId}/assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a plan as auto assignable.
 *
 * Allows a user to mark a plan as auto assignable.
 */
export const patchAutoAssign = <ThrowOnError extends boolean = false>(options: Options<PatchAutoAssignData, ThrowOnError>): RequestResult<PatchAutoAssignResponses, PatchAutoAssignErrors, ThrowOnError> => (options.client ?? client).patch<PatchAutoAssignResponses, PatchAutoAssignErrors, ThrowOnError>({
    url: '/plans/{planId}/autoAssign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clone a plan.
 */
export const clonePlan = <ThrowOnError extends boolean = false>(options: Options<ClonePlanData, ThrowOnError>): RequestResult<ClonePlanResponses, ClonePlanErrors, ThrowOnError> => (options.client ?? client).post<ClonePlanResponses, ClonePlanErrors, ThrowOnError>({
    url: '/plans/{planId}/clone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clone a plan as a system plan.
 */
export const cloneAsSystemPlan = <ThrowOnError extends boolean = false>(options: Options<CloneAsSystemPlanData, ThrowOnError>): RequestResult<CloneAsSystemPlanResponses, CloneAsSystemPlanErrors, ThrowOnError> => (options.client ?? client).post<CloneAsSystemPlanResponses, CloneAsSystemPlanErrors, ThrowOnError>({
    url: '/plans/{planId}/clone/asSystem',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a users plan due date.
 *
 * Changes when a user's plan is due by.
 */
export const updateDueDate = <ThrowOnError extends boolean = false>(options: Options<UpdateDueDateData, ThrowOnError>): RequestResult<UpdateDueDateResponses, UpdateDueDateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDueDateResponses, UpdateDueDateErrors, ThrowOnError>({
    url: '/plans/{planId}/dueDate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark plan as complete when all steps are complete.
 *
 * Records when a user is complete with a plan.
 */
export const markPlanAsComplete = <ThrowOnError extends boolean = false>(options: Options<MarkPlanAsCompleteData, ThrowOnError>): RequestResult<MarkPlanAsCompleteResponses, MarkPlanAsCompleteErrors, ThrowOnError> => (options.client ?? client).patch<MarkPlanAsCompleteResponses, MarkPlanAsCompleteErrors, ThrowOnError>({ url: '/plans/{planId}/markAsComplete', ...options });

/**
 * Updates the plan name.
 *
 * Updates the plan name. The name must be a localized `TranslatedField` with
 * at least one non-blank translation, and each translation must not exceed 200 characters.
 */
export const patchPlanName = <ThrowOnError extends boolean = false>(options: Options<PatchPlanNameData, ThrowOnError>): RequestResult<PatchPlanNameResponses, PatchPlanNameErrors, ThrowOnError> => (options.client ?? client).patch<PatchPlanNameResponses, PatchPlanNameErrors, ThrowOnError>({
    url: '/plans/{planId}/name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Allow users to opt-in or out of readonly plans.
 *
 * Subscribes a location/operator to a readonly plan.
 */
export const upsertReadonlySubscription = <ThrowOnError extends boolean = false>(options: Options<UpsertReadonlySubscriptionData, ThrowOnError>): RequestResult<UpsertReadonlySubscriptionResponses, UpsertReadonlySubscriptionErrors, ThrowOnError> => (options.client ?? client).put<UpsertReadonlySubscriptionResponses, UpsertReadonlySubscriptionErrors, ThrowOnError>({
    url: '/plans/{planId}/readonly/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a plan's status.
 *
 * Allows a user to archive and unarchive a plan.
 */
export const patchPlanStatus = <ThrowOnError extends boolean = false>(options: Options<PatchPlanStatusData, ThrowOnError>): RequestResult<PatchPlanStatusResponses, PatchPlanStatusErrors, ThrowOnError> => (options.client ?? client).patch<PatchPlanStatusResponses, PatchPlanStatusErrors, ThrowOnError>({
    url: '/plans/{planId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resets all the steps in a plan.
 *
 * Resets all the steps in a plan to incomplete.
 */
export const resetPlanSteps = <ThrowOnError extends boolean = false>(options: Options<ResetPlanStepsData, ThrowOnError>): RequestResult<ResetPlanStepsResponses, ResetPlanStepsErrors, ThrowOnError> => (options.client ?? client).put<ResetPlanStepsResponses, ResetPlanStepsErrors, ThrowOnError>({
    url: '/plans/{planId}/steps/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update duration for logged in user's plan and step.
 *
 * Records how long a user takes on a given plan and step.
 */
export const heartbeat = <ThrowOnError extends boolean = false>(options: Options<HeartbeatData, ThrowOnError>): RequestResult<HeartbeatResponses, HeartbeatErrors, ThrowOnError> => (options.client ?? client).put<HeartbeatResponses, HeartbeatErrors, ThrowOnError>({
    url: '/plans/{planId}/steps/{stepId}/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a step status to complete.
 *
 * Updates a single step status to complete.
 */
export const updateStepStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateStepStatusData, ThrowOnError>): RequestResult<UpdateStepStatusResponses, UpdateStepStatusErrors, ThrowOnError> => (options.client ?? client).put<UpdateStepStatusResponses, UpdateStepStatusErrors, ThrowOnError>({
    url: '/plans/{planId}/steps/{stepId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update duration for passed in user's plan and step in train together.
 *
 * Records how long the passed in users take on the given plan and step in train together.
 */
export const heartbeatTrainTogether = <ThrowOnError extends boolean = false>(options: Options<HeartbeatTrainTogetherData, ThrowOnError>): RequestResult<HeartbeatTrainTogetherResponses, HeartbeatTrainTogetherErrors, ThrowOnError> => (options.client ?? client).put<HeartbeatTrainTogetherResponses, HeartbeatTrainTogetherErrors, ThrowOnError>({
    url: '/plans/{planId}/steps/{stepId}/trainTogether/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark the passed in plan's step status for the user ids in training mode.
 */
export const trainTogetherUpdateStepStatus = <ThrowOnError extends boolean = false>(options: Options<TrainTogetherUpdateStepStatusData, ThrowOnError>): RequestResult<TrainTogetherUpdateStepStatusResponses, TrainTogetherUpdateStepStatusErrors, ThrowOnError> => (options.client ?? client).put<TrainTogetherUpdateStepStatusResponses, TrainTogetherUpdateStepStatusErrors, ThrowOnError>({
    url: '/plans/{planId}/steps/{stepId}/trainTogether/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark plan as complete for the passed user ids in training together.
 *
 * Records when a user is complete with a plan in training together.
 */
export const trainTogetherMarkPlanAsComplete = <ThrowOnError extends boolean = false>(options: Options<TrainTogetherMarkPlanAsCompleteData, ThrowOnError>): RequestResult<TrainTogetherMarkPlanAsCompleteResponses, TrainTogetherMarkPlanAsCompleteErrors, ThrowOnError> => (options.client ?? client).patch<TrainTogetherMarkPlanAsCompleteResponses, TrainTogetherMarkPlanAsCompleteErrors, ThrowOnError>({
    url: '/plans/{planId}/trainTogether/markAsComplete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets a list of quizzes
 *
 * Gets a list of owned Classic and Knowledge quizzes
 */
export const getQuizzes = <ThrowOnError extends boolean = false>(options?: Options<GetQuizzesData, ThrowOnError>): RequestResult<GetQuizzesResponses, GetQuizzesErrors, ThrowOnError> => (options?.client ?? client).get<GetQuizzesResponses, GetQuizzesErrors, ThrowOnError>({ url: '/quizzes', ...options });

/**
 * Create a quiz
 */
export const createQuiz = <ThrowOnError extends boolean = false>(options: Options<CreateQuizData, ThrowOnError>): RequestResult<CreateQuizResponses, CreateQuizErrors, ThrowOnError> => (options.client ?? client).post<CreateQuizResponses, CreateQuizErrors, ThrowOnError>({
    url: '/quizzes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hard-delete a quiz (maintenance)
 *
 * Lower-env maintenance cleanup. Removes pathway quiz metadata and Typeform form. Callers supply typeFormId. Forbidden in production.
 */
export const hardDeleteQuiz = <ThrowOnError extends boolean = false>(options: Options<HardDeleteQuizData, ThrowOnError>): RequestResult<HardDeleteQuizResponses, HardDeleteQuizErrors, ThrowOnError> => (options.client ?? client).delete<HardDeleteQuizResponses, HardDeleteQuizErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/quizzes/maintenance/{quizId}',
    ...options
});

/**
 * Delete a quiz
 */
export const deleteQuiz = <ThrowOnError extends boolean = false>(options: Options<DeleteQuizData, ThrowOnError>): RequestResult<DeleteQuizResponses, DeleteQuizErrors, ThrowOnError> => (options.client ?? client).delete<DeleteQuizResponses, DeleteQuizErrors, ThrowOnError>({ url: '/quizzes/{quizId}', ...options });

/**
 * Get quiz details
 */
export const getQuizDetails = <ThrowOnError extends boolean = false>(options: Options<GetQuizDetailsData, ThrowOnError>): RequestResult<GetQuizDetailsResponses, GetQuizDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetQuizDetailsResponses, GetQuizDetailsErrors, ThrowOnError>({ url: '/quizzes/{quizId}', ...options });

/**
 * Update a quiz
 */
export const updateQuiz = <ThrowOnError extends boolean = false>(options: Options<UpdateQuizData, ThrowOnError>): RequestResult<UpdateQuizResponses, UpdateQuizErrors, ThrowOnError> => (options.client ?? client).put<UpdateQuizResponses, UpdateQuizErrors, ThrowOnError>({
    url: '/quizzes/{quizId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates the quiz name.
 *
 * Updates the quiz name. The name must be a localized `TranslatedField` with at least one
 * non-blank translation. The primary-language value is limited to 250 characters;
 * other translations may be up to 750 characters (knowledge based quizzes only).
 */
export const patchQuizName = <ThrowOnError extends boolean = false>(options: Options<PatchQuizNameData, ThrowOnError>): RequestResult<PatchQuizNameResponses, PatchQuizNameErrors, ThrowOnError> => (options.client ?? client).patch<PatchQuizNameResponses, PatchQuizNameErrors, ThrowOnError>({
    url: '/quizzes/{quizId}/name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview a resource swap.
 *
 * Compares persistent and temporary resources, returns an afterSwap projection when both exist, and enriches subtitle placements with browse category paths.
 */
export const diff = <ThrowOnError extends boolean = false>(options: Options<DiffData, ThrowOnError>): RequestResult<DiffResponses, DiffErrors, ThrowOnError> => (options.client ?? client).get<DiffResponses, DiffErrors, ThrowOnError>({ url: '/resources/swap', ...options });

/**
 * Swap a temporary resource onto a persistent resource.
 *
 * Swaps resource content references and returns affected categories requiring review.
 */
export const swap = <ThrowOnError extends boolean = false>(options: Options<SwapData, ThrowOnError>): RequestResult<SwapResponses, SwapErrors, ThrowOnError> => (options.client ?? client).post<SwapResponses, SwapErrors, ThrowOnError>({
    url: '/resources/swap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rewrite plan step resource references.
 *
 * Proxies to plans-data-api to publish an asynchronous plan-job that rewrites matching plan step references from one resource to another. Usable as a standalone rewrite or after a resource swap. Returns 202 with the published job id.
 */
export const rewritePlanReferences = <ThrowOnError extends boolean = false>(options: Options<RewritePlanReferencesData, ThrowOnError>): RequestResult<RewritePlanReferencesResponses, RewritePlanReferencesErrors, ThrowOnError> => (options.client ?? client).post<RewritePlanReferencesResponses, RewritePlanReferencesErrors, ThrowOnError>({
    url: '/resources/swap/plan-references',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a resource
 *
 * Returns complete resource structure by id
 */
export const getResource = <ThrowOnError extends boolean = false>(options: Options<GetResourceData, ThrowOnError>): RequestResult<GetResourceResponses, GetResourceErrors, ThrowOnError> => (options.client ?? client).get<GetResourceResponses, GetResourceErrors, ThrowOnError>({ url: '/resources/{id}', ...options });

/**
 * Search for results
 *
 * Searches for resources by query, country and language. Returns document results along with optional GenAI smart answers. Smart answers include source attribution with document titles, URLs, text excerpts, and confidence scores.
 */
export const search = <ThrowOnError extends boolean = false>(options: Options<SearchData, ThrowOnError>): RequestResult<SearchResponses, SearchErrors, ThrowOnError> => (options.client ?? client).get<SearchResponses, SearchErrors, ThrowOnError>({ url: '/search', ...options });

/**
 * Submit click feedback for a result
 *
 * Improves search results by submitting click feedback for a specific result and query.
 */
export const searchClickFeedback = <ThrowOnError extends boolean = false>(options: Options<SearchClickFeedbackData, ThrowOnError>): RequestResult<SearchClickFeedbackResponses, SearchClickFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SearchClickFeedbackResponses, SearchClickFeedbackErrors, ThrowOnError>({ url: '/search-click-feedback', ...options });

/**
 * Get smart search opt-in status per owner for locations the user can manage.
 */
export const getSmartSearchLocations = <ThrowOnError extends boolean = false>(options?: Options<GetSmartSearchLocationsData, ThrowOnError>): RequestResult<GetSmartSearchLocationsResponses, GetSmartSearchLocationsErrors, ThrowOnError> => (options?.client ?? client).get<GetSmartSearchLocationsResponses, GetSmartSearchLocationsErrors, ThrowOnError>({ url: '/settings/smart-search', ...options });

/**
 * Opt in or out of smart search for one or more restaurants.
 */
export const updateSmartSearchOptIn = <ThrowOnError extends boolean = false>(options: Options<UpdateSmartSearchOptInData, ThrowOnError>): RequestResult<UpdateSmartSearchOptInResponses, UpdateSmartSearchOptInErrors, ThrowOnError> => (options.client ?? client).put<UpdateSmartSearchOptInResponses, UpdateSmartSearchOptInErrors, ThrowOnError>({
    url: '/settings/smart-search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert smart search answer feedback
 *
 * Creates or updates thumb feedback (0/1) for a smart search answer trace. An optional written comment may be included with the thumb rating.
 */
export const upsertSmartSearchFeedback = <ThrowOnError extends boolean = false>(options: Options<UpsertSmartSearchFeedbackData, ThrowOnError>): RequestResult<UpsertSmartSearchFeedbackResponses, UpsertSmartSearchFeedbackErrors, ThrowOnError> => (options.client ?? client).put<UpsertSmartSearchFeedbackResponses, UpsertSmartSearchFeedbackErrors, ThrowOnError>({
    url: '/smart-search-feedback/{traceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Natural Language Translations
 *
 * Facilitates translation from one natural language to another.
 */
export const getTranslations = <ThrowOnError extends boolean = false>(options: Options<GetTranslationsData, ThrowOnError>): RequestResult<GetTranslationsResponses, GetTranslationsErrors, ThrowOnError> => (options.client ?? client).post<GetTranslationsResponses, GetTranslationsErrors, ThrowOnError>({
    url: '/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Find users assigned to locations
 *
 * Find users assigned to locations.
 */
export const getUsersForLocations = <ThrowOnError extends boolean = false>(options?: Options<GetUsersForLocationsData, ThrowOnError>): RequestResult<GetUsersForLocationsResponses, GetUsersForLocationsErrors, ThrowOnError> => (options?.client ?? client).get<GetUsersForLocationsResponses, GetUsersForLocationsErrors, ThrowOnError>({ url: '/users', ...options });

/**
 * Get users by locations
 *
 * @deprecated
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>): RequestResult<GetUsersResponses, GetUsersErrors, ThrowOnError> => (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError>({ url: '/users/list', ...options });

/**
 * Get operators and locations
 */
export const getOperators = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorsData, ThrowOnError>): RequestResult<GetOperatorsResponses, GetOperatorsErrors, ThrowOnError> => (options?.client ?? client).get<GetOperatorsResponses, GetOperatorsErrors, ThrowOnError>({ url: '/users/operators', ...options });

/**
 * Retrieve user preferences
 */
export const getUserPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetUserPreferencesData, ThrowOnError>): RequestResult<GetUserPreferencesResponses, GetUserPreferencesErrors, ThrowOnError> => (options?.client ?? client).get<GetUserPreferencesResponses, GetUserPreferencesErrors, ThrowOnError>({ url: '/users/preferences', ...options });

/**
 * Save user preferences
 */
export const saveUserPreferences = <ThrowOnError extends boolean = false>(options: Options<SaveUserPreferencesData, ThrowOnError>): RequestResult<SaveUserPreferencesResponses, SaveUserPreferencesErrors, ThrowOnError> => (options.client ?? client).post<SaveUserPreferencesResponses, SaveUserPreferencesErrors, ThrowOnError>({
    url: '/users/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Plan Assignment Summaries
 *
 * Returns a summary of the user's plan assignments.
 */
export const getUserPlanAssignmentSummaries = <ThrowOnError extends boolean = false>(options: Options<GetUserPlanAssignmentSummariesData, ThrowOnError>): RequestResult<GetUserPlanAssignmentSummariesResponses, GetUserPlanAssignmentSummariesErrors, ThrowOnError> => (options.client ?? client).get<GetUserPlanAssignmentSummariesResponses, GetUserPlanAssignmentSummariesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/plans/assignments',
    ...options
});

/**
 * Store quiz results for plan from Typeform
 */
export const webhookQuiz = <ThrowOnError extends boolean = false>(options: Options<WebhookQuizData, ThrowOnError>): RequestResult<WebhookQuizResponses, WebhookQuizErrors, ThrowOnError> => (options.client ?? client).post<WebhookQuizResponses, WebhookQuizErrors, ThrowOnError>({
    url: '/webhook/plans/quiz',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
